import React from 'react';
import Grid from '@material-ui/core/Grid';
import { NotificationCard } from 'core/components/notification-card';
import useStyles from './incorrect-billing-warning.styles';

const IncorrectBillingWarning = () => {
  const classes = useStyles();

  return (
    <NotificationCard
      className={classes.notification}
      iconSize="icon16"
      type="infoGreen"
      header="Incorrect billing information can delay processing and lead to lapses in coverage"
    >
      <Grid container justifyContent="space-between">
        <div>
          Since this lender isn't in our database yet, please provide accurate information to process billing for
          escrow-billed policies. Include the email and fax, if available, to expedite billing, as they can serve as
          additional methods for payment collection.
        </div>
      </Grid>
    </NotificationCard>
  );
};

IncorrectBillingWarning.propTypes = {};

export default IncorrectBillingWarning;
